export default __webpack_public_path__ + "fonts/poppins-latin-100-normal.2b594700d9cd577a8c7c.woff";